import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import type { DataSource } from "./data/source";
import type { Role } from "./data/types";
import "./index.css";
import { runsLive } from "./lib/mode";

// Demo mode when Supabase is not configured, or explicitly with ?demo=<role> — never on the firm's own domain (lib/mode.ts).
const env = import.meta.env;
const params = new URLSearchParams(window.location.search);
const live = runsLive(window.location.hostname, params, Boolean(env.VITE_SUPABASE_URL && env.VITE_SUPABASE_ANON_KEY));
const roles: Role[] = ["partner", "manager", "staff", "client"];
const asked = params.get("demo") as Role | null;

async function start() {
  // Each source loads on demand, so the demo build carries no Supabase client and the live build no demo data.
  const ds: DataSource = live
    ? new (await import("./data/supabase")).SupabaseSource(env.VITE_SUPABASE_URL!, env.VITE_SUPABASE_ANON_KEY!, env.VITE_PORTAL_WORKER_URL || "")
    : await (await import("./data/demo")).createDemoSource(asked && roles.includes(asked) ? asked : params.has("demo") ? "manager" : null);
  ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><App ds={ds} /></React.StrictMode>);
}
void start();
